const isValueEmpty = (value: unknown): value is undefined | null | '' => {
  return value === undefined || value === null || value === '';
};

const isValueEmptyOrZero = (value: unknown): value is undefined | null | '' => {
  return value === undefined || value === null || value === '' || value === 0;
};

export { isValueEmpty, isValueEmptyOrZero };
